import React, { Fragment, useEffect, useState } from 'react';
import _uniqueId from 'lodash/uniqueId';


const BiFormTable = (props) => {

    if (props.responsive == true) {

        return (

            <div className="container" style={{padding:"3px"}} >
                {props.children}
            </div>

        );
    } else {
        return (
            <Fragment>
                <table style={{ ...props.style, ...{ tableLayout: "fixed", width: "100%" } }}>
                    <colgroup>
                        {props.columns.map((col, index) => {

                            return (
                                <col key={_uniqueId('bic-')} style={{ width: col.width }} />
                            );
                        })}
                    </colgroup>
                    <tbody cols={props.columns.length}>
                        {props.children}
                    </tbody>

                </table>
            </Fragment>
        );
    }
}

export default BiFormTable;

